var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuadroRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(-427.331 226.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M261.549-345.366v222h222v-222ZM456.311-150.292h-45.14v-9.88H298.354v-148.4H446.744v113.143h9.568Z",
    transform: "translate(165.782 119.339)",
    fill: "#13ab9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2",
    "data-name": "Rettangolo 2",
    width: 63.537,
    height: 63.537,
    transform: "translate(569.83 -148.37) rotate(90)",
    fill: "#13ab9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadroRed);
export default __webpack_public_path__ + "static/media/quadro-red.15ed94523e310ac99d4f8be131bb3c1b.svg";
export { ForwardRef as ReactComponent };